import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdEdit, MdAddCircle, MdFilterList, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import AppDataGrid from "../../components/common/AppDataGrid";

const Leaves = () => {
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [filter, setFilter] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const userData = sessionStorage.getItem('user');
    const [leaves, setleaves] = useState([]);
    const userObj = userData ? JSON.parse(userData) : {};
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const [form, setForm] = useState({
        leave_id: "",
        leave_description: "",
        leave_code: "",
        yearly_accumulation: "",
        consider_holidays: "",
        combination_of_leaves: "",
        consider_half_day: "",
        max_days_to_avail: "",
        max_accumulation: "",
        consider_encashment: "",
        consider_lapse: "",
        max_carryforward: "",
        school_id: "",
        school_name: "",
    });

    const fetchleaves = async () => {
        try {
            const response = await axios.post(baseUrl + "/LeaveMasterRead/", {
                action: "READ",
                school_id: userObj.school_id,
            });
            setleaves(response.data || []);
            console.log(response.data);
        } catch (error) {
            console.error("Error fetching leaves:", error);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        fetchleaves().finally(() => setIsLoading(false));
    }, []);

    const handleEditClick = (leave_id) => {
        const leaveToEdit = leaves.find(leaves => leaves.leave_id === leave_id);
        console.log(leaveToEdit);
        if (leaveToEdit) {
            navigate("/addnewleavemaster", { state: { leaveData: leaveToEdit } });
        } else {
            console.error("ID ${ leave_id } not found");
        }
    };

    const handleDeleteClick = async (leave_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');
        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            leave_id: leave_id,
            action: "DELETE"
        };
        try {
            const response = await axios.post(baseUrl + '/LeaveMaster/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Set to InActive");
            fetchleaves();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleReset = async (e) => {
        e.preventDefault();
        setFilter({
            leave_description: "",
            leave_code: "",
            action: "FILTER"
        });
        setShowFilterModal(true);
        fetchleaves();
    };

    const columns = [
        {
            field: "leave_description",
            headerName: "Leave Type",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "leave_code",
            headerName: "Leave Code",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },

        {
            field: "yearly_accumulation",
            headerName: "Yearly Accumulation",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "monthlyfrequency",
            headerName: "Accumulation Frequency",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "monthly_accumulation",
            headerName: "Accumulation Value",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "max_accumulation",
            headerName: "Max Accumulation",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "max_days_to_avail",
            headerName: "Max Days to Avail",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        // {
        //     field: "max_carryforward",
        //     headerName: "Max Carryforward",
        //     flex: 1,
        //     renderCell: (params) => (
        //         <Tooltip title={params.value}>
        //             <span className="cell-wrap">{params.value}</span>
        //         </Tooltip>
        //     ),
        // },
        {
            field: "consider_holidays",
            headerName: "Consider Holidays",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "combination_of_leaves",
            headerName: "Combination of Leaves",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "consider_half_day",
            headerName: "Consider Half Day",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        // {
        //     field: "consider_encashment",
        //     headerName: "Consider Encashment",
        //     flex: 1,
        //     renderCell: (params) => (
        //         <Tooltip title={params.value}>
        //             <span className="cell-wrap">{params.value}</span>
        //         </Tooltip>
        //     ),
        // },
        // {
        //     field: "consider_lapse",
        //     headerName: "Consider Lapse",
        //     flex: 1,
        //     renderCell: (params) => (
        //         <Tooltip title={params.value}>
        //             <span className="cell-wrap">{params.value}</span>
        //         </Tooltip>
        //     ),
        // },
        {
            field: "restrict_holidays",
            headerName: "Restrict Holidays",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "restrict_weekends",
            headerName: "Restrict Weekends",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },

        {
            field: "is_active",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            sortable: false,
            renderCell: (params) =>
                params.row.consider_half_day !== "No records found" ? (
                    <div className="tableActions">
                        <Tooltip title="Edit" arrow>
                            <span
                                className="commonActionIcons"
                                onClick={() => handleEditClick(params.row.leave_id)}
                            >
                                <MdEdit />
                            </span>
                        </Tooltip>
                        <Tooltip title="Delete" arrow>
                            <span
                                className="commonActionIcons"
                                onClick={() => handleDeleteClick(params.row.leave_id)}
                            >
                                <MdDelete />
                            </span>
                        </Tooltip>
                    </div>
                ) : null,
        },
    ];

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (/^[A-Za-z\s]*$/.test(value)) {
            setFilter((prev) => ({
                ...prev,
                [id]: value,
            }));
        }
    };

    const handleFilterSubmit = async () => {
        try {
            const response = await axios.post(baseUrl + "/LeaveMasterRead/", {
                action: "FILTER",
                school_id: userObj.school_id,
                leave_description: filter.leave_description || "",
                leave_code: filter.leave_code || "",
            });

            setleaves(response.data || []);
            handleCloseFilterModal();
        } catch (error) {

            setleaves([]);
            handleCloseFilterModal();

        }
    };

    const searchableColumns = [
        (row) => row.leave_description,
        (row) => row.leave_code,
    ];

    const filteredRecords = (leaves || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toUpperCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toUpperCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (
        <div className="pageBody">
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Leave Master</h6>
                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            maxLength={15}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>

                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                            <Button className="primaryBtn" variant="primary" onClick={() => navigate("/addnewleavemaster")}>
                                <MdAddCircle />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            // ✅ pass only real rows – DataGrid will show its own "No rows" overlay
                            rows={filteredRecords}
                            columns={columns}
                            getRowId={(row) => row.leave_id}
                            showToolbar={false}
                            pagination
                            pageSizeOptions={[10, 20, 50]}
                            density="compact"
                            maxHeight={550}
                        />
                    )}
                </div>
            </div>

            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="leave_description">
                                    <Form.Label>Leave Type</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="leave_description"
                                        value={filter.leave_description}
                                        placeholder="Enter Leave Type"
                                        maxLength={30}
                                        onChange={(e) => {
                                            let value = e.target.value;

                                            value = value.trimStart();

                                            if (/^[A-Za-z\s]*$/.test(value)) {

                                                value = value.slice(0, 30);

                                                handleInputChange({
                                                    target: { id: "leave_description", value }
                                                });
                                            }
                                        }}
                                    />
                                </Form.Group>
                            </div>
                        </Col>

                        <Col xs={12}>
                            <Col xs={12}>
                                <div className='commonInput'>
                                    <Form.Group controlId="leave_code">
                                        <Form.Label>Leave Code </Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="leave_code"
                                            placeholder="Enter Leave Code"
                                            value={filter.leave_code}
                                            maxLength={3}
                                            onChange={(e) => {
                                                let value = e.target.value;

                                                value = value.replace(/^\s+/, "");

                                                value = value.replace(/[^A-Za-z]/g, "");

                                                handleInputChange({
                                                    target: {
                                                        id: "leave_code",
                                                        value: value
                                                    }
                                                });
                                            }}
                                        />
                                    </Form.Group>
                                </div>
                            </Col>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => { handleCloseFilterModal(); }}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="btn-success primaryBtn" onClick={handleFilterSubmit}>
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Leaves;
